// Datos de cotizaciones del dólar (hardcodeados para performance en tooltips)
// Actualizados el 2025-11-25 con datos de argentinadatos.com API
export const cotizacionesDolar = {
  '2025-11': { Oficial: { venta: 1500.00 }, Blue: { venta: 1445.00 } },
  '2025-10': { Oficial: { venta: 1450.00 }, Blue: { venta: 1460.00 } },
  '2025-09': { Oficial: { venta: 1385.00 }, Blue: { venta: 1370.00 } },
  '2025-08': { Oficial: { venta: 1375.00 }, Blue: { venta: 1335.00 } },
  '2025-07': { Oficial: { venta: 1235.00 }, Blue: { venta: 1225.00 } },
  '2025-06': { Oficial: { venta: 1200.00 }, Blue: { venta: 1165.00 } },
  '2025-05': { Oficial: { venta: 1190.00 }, Blue: { venta: 1185.00 } },
  '2025-04': { Oficial: { venta: 1094.25 }, Blue: { venta: 1315.00 } },
  '2025-03': { Oficial: { venta: 1084.25 }, Blue: { venta: 1230.00 } },
  '2025-02': { Oficial: { venta: 1074.25 }, Blue: { venta: 1220.00 } },
  '2025-01': { Oficial: { venta: 1052.50 }, Blue: { venta: 1230.00 } },
  '2024-12': { Oficial: { venta: 1042.00 }, Blue: { venta: 1100.00 } },
  '2024-11': { Oficial: { venta: 1021.00 }, Blue: { venta: 1190.00 } },
  '2024-10': { Oficial: { venta: 1006.00 }, Blue: { venta: 1220.00 } },
  '2024-09': { Oficial: { venta: 991.00 }, Blue: { venta: 1305.00 } },
  '2024-08': { Oficial: { venta: 972.00 }, Blue: { venta: 1380.00 } },
  '2024-07': { Oficial: { venta: 954.00 }, Blue: { venta: 1405.00 } },
  '2024-06': { Oficial: { venta: 938.00 }, Blue: { venta: 1235.00 } },
  '2024-05': { Oficial: { venta: 921.00 }, Blue: { venta: 1055.00 } },
  '2024-04': { Oficial: { venta: 902.00 }, Blue: { venta: 1010.00 } },
  '2024-03': { Oficial: { venta: 889.00 }, Blue: { venta: 1050.00 } },
  '2024-02': { Oficial: { venta: 873.00 }, Blue: { venta: 1195.00 } },
  '2024-01': { Oficial: { venta: 847.00 }, Blue: { venta: 1025.00 } },
  '2023-12': { Oficial: { venta: 379.00 }, Blue: { venta: 955.00 } },
  '2023-11': { Oficial: { venta: 368.00 }, Blue: { venta: 915.00 } },
  '2023-10': { Oficial: { venta: 367.00 }, Blue: { venta: 800.00 } },
  '2023-09': { Oficial: { venta: 367.00 }, Blue: { venta: 730.00 } },
  '2023-08': { Oficial: { venta: 289.00 }, Blue: { venta: 560.00 } },
  '2023-07': { Oficial: { venta: 272.00 }, Blue: { venta: 495.00 } },
  '2023-06': { Oficial: { venta: 251.00 }, Blue: { venta: 490.00 } },
  '2023-05': { Oficial: { venta: 230.00 }, Blue: { venta: 469.00 } },
  '2023-04': { Oficial: { venta: 217.00 }, Blue: { venta: 392.00 } },
  '2023-03': { Oficial: { venta: 205.00 }, Blue: { venta: 375.00 } },
  '2023-02': { Oficial: { venta: 195.00 }, Blue: { venta: 377.00 } },
  '2023-01': { Oficial: { venta: 185.00 }, Blue: { venta: 346.00 } },
  '2022-12': { Oficial: { venta: 176.00 }, Blue: { venta: 334.00 } },
  '2022-11': { Oficial: { venta: 169.00 }, Blue: { venta: 320.00 } },
  '2022-10': { Oficial: { venta: 162.00 }, Blue: { venta: 298.00 } },
  '2022-09': { Oficial: { venta: 155.00 }, Blue: { venta: 287.00 } },
  '2022-08': { Oficial: { venta: 148.00 }, Blue: { venta: 288.00 } },
  '2022-07': { Oficial: { venta: 140.00 }, Blue: { venta: 338.00 } },
  '2022-06': { Oficial: { venta: 133.00 }, Blue: { venta: 238.00 } },
  '2022-05': { Oficial: { venta: 125.00 }, Blue: { venta: 207.00 } },
  '2022-04': { Oficial: { venta: 118.00 }, Blue: { venta: 204.00 } },
  '2022-03': { Oficial: { venta: 111.00 }, Blue: { venta: 202.00 } },
  '2022-02': { Oficial: { venta: 109.00 }, Blue: { venta: 206.00 } },
  '2022-01': { Oficial: { venta: 108.00 }, Blue: { venta: 208.00 } },
  '2021-12': { Oficial: { venta: 108.00 }, Blue: { venta: 208.00 } },
  '2021-11': { Oficial: { venta: 107.00 }, Blue: { venta: 200.00 } },
  '2021-10': { Oficial: { venta: 105.00 }, Blue: { venta: 196.00 } },
  '2021-09': { Oficial: { venta: 104.00 }, Blue: { venta: 186.00 } },
  '2021-08': { Oficial: { venta: 103.00 }, Blue: { venta: 180.00 } },
  '2021-07': { Oficial: { venta: 102.00 }, Blue: { venta: 180.00 } },
  '2021-06': { Oficial: { venta: 101.00 }, Blue: { venta: 169.00 } },
  '2021-05': { Oficial: { venta: 100.00 }, Blue: { venta: 155.00 } },
  '2021-04': { Oficial: { venta: 99.00 }, Blue: { venta: 150.00 } },
  '2021-03': { Oficial: { venta: 98.00 }, Blue: { venta: 141.00 } },
  '2021-02': { Oficial: { venta: 95.00 }, Blue: { venta: 147.00 } },
  '2021-01': { Oficial: { venta: 93.00 }, Blue: { venta: 153.00 } }
};

// Función para calcular conversiones de dólar de forma síncrona
export const calcularConversionesDolarAproximadas = (montoPesos, periodo) => {
  try {
    console.log('🔄 Iniciando conversión USD:', { montoPesos, periodo });
    
    if (!montoPesos || montoPesos === 0) {
      console.log('⚠️ Monto en pesos es 0 o inválido');
      return { oficial: 0, blue: 0 };
    }
    
    let año, mes;
    
    if (periodo && periodo.includes(' ')) {
      const partes = periodo.split(' ');
      mes = partes[0];
      año = partes[1];
    } else if (periodo) {
      const match = periodo.match(/([A-Za-z]+)(\d{2})$/);
      if (match) {
        mes = match[1];
        año = `20${match[2]}`;
      } else {
        console.log('⚠️ No se pudo parsear el período:', periodo);
        return { oficial: 0, blue: 0 };
      }
    } else {
      console.log('⚠️ Período no proporcionado');
      return { oficial: 0, blue: 0 };
    }
    
    console.log('📅 Período parseado:', { mes, año });
    
    const mesesMap = {
      'Enero': '01', 'Febrero': '02', 'Marzo': '03', 'Abril': '04',
      'Mayo': '05', 'Junio': '06', 'Julio': '07', 'Agosto': '08',
      'Septiembre': '09', 'Octubre': '10', 'Noviembre': '11', 'Diciembre': '12'
    };
    
    const numeroMes = mesesMap[mes];
    if (!numeroMes) {
      console.log('⚠️ Mes no encontrado en el mapa:', mes);
      return { oficial: 0, blue: 0 };
    }
    
    const claveFecha = `${año}-${numeroMes}`;
    console.log('🔍 Buscando cotización para:', claveFecha);
    
    const cotizaciones = cotizacionesDolar[claveFecha];
    
    if (!cotizaciones) {
      console.log('⚠️ No se encontraron cotizaciones para:', claveFecha);
      console.log('📋 Claves disponibles:', Object.keys(cotizacionesDolar).slice(0, 10));
      return { oficial: 0, blue: 0 };
    }
    
    console.log('💰 Cotizaciones encontradas:', cotizaciones);
    
    const dolarOficial = montoPesos / cotizaciones.Oficial.venta;
    const dolarBlue = montoPesos / cotizaciones.Blue.venta;
    
    const resultado = {
      oficial: dolarOficial,
      blue: dolarBlue
    };
    
    console.log('✅ Conversión completada:', resultado);
    
    return resultado;
  } catch (error) {
    return { oficial: 0, blue: 0 };
  }
};

// Función para formatear montos en dólares
export const formatearDolares = (monto, tipo = 'oficial') => {
  if (!monto || monto === 0) return 'USD 0';
  return `USD ${monto.toLocaleString('es-AR', { 
    minimumFractionDigits: 0, 
    maximumFractionDigits: 0 
  })} ${tipo === 'blue' ? '(Blue)' : '(Oficial)'}`;
};